<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
import CsImage from '@/onenetwork/components/csimage/CsImage.vue'
import { beautyPhoneNumber, getFirstCharacterName } from '@/utils/helper.ts'

interface Props {
  data: object | string | number,
  cellConfig: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  return (typeof props.data === 'string') ? props.data : ''
})

const width = computed(() => {
  return props.cellConfig?.config?.width || '60px'
})

const height = computed(() => {
  return props.cellConfig?.config?.height || '60px'
})

const borderRadius = computed(() => {
  return props.cellConfig?.config?.borderRadius || '4px'
})
</script>

<template>
  <div class="flex items-center gap-3">
    <div class="thumb">
      <div class="p-avatar p-component p-avatar-image p-avatar-lg" v-if="props.data?.avatar">
        <cs-image :src="props.data?.avatar"/>
      </div>
      <Avatar size="large" :label="getFirstCharacterName(props.data?.full_name)" style="background-color: #f4f4f4; color: #d1d1d1" v-else/>
    </div>
    <div class="info">
      <div class="font-bold text-[#00337a]" style="color: #00337a">{{ props.data?.full_name }}</div>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center text-[11px]">
          <Icon icon="zondicons:phone" color="#c9c9c9"/> {{beautyPhoneNumber(props.data?.phone)}}
        </div>
        <div class="flex gap-2 items-center text-[11px]">
          <Icon icon="ic:baseline-email" color="#c9c9c9"/> {{props.data?.email}}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
